import React, { Component } from 'react';
import { View, Image } from 'react-native';

import { COLOR, THEME } from '../../../../constants/styles';

export default class ImagePicker extends Component {
  static selectImage = (fileType) => {
    return new Promise((resolve, reject) => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = fileType || 'image/*, video/mp4';
      input.style = '{display: none;}';
      input.onchange = (event) => {
        // TODO: @hcw add checks for bad inputs here
        const file = input?.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
          // get loaded data and render thumbnail.
          resolve({
            image: {
              uri: e.target.result,
              file: file,
              fileName: file.name,
              size: file.size,
              type: file.type,
            },
          });
        };

        // read the image file as a data URL.
        reader.readAsDataURL(file);
      };
      input.click();
    });
  };

  constructor(props) {
    super(props);

    this.state = {
      over: false,
    };
  }

  handleDrop = (ev) => {
    ev.preventDefault();

    let files = [];

    if (ev.dataTransfer.items) {
      files = [...ev.dataTransfer.items].map((item, i) => {
        if (item.kind === 'file' && item.type === this.props.fileType) {
          return item.getAsFile();
        }
        return null;
      });
    } else {
      files = [...ev.dataTransfer.files];
    }

    const pdfFiles = files
      .filter((f) => f !== null)
      .map((file) => {
        return {
          image: {
            uri: null,
            file,
            fileName: file.name,
            size: file.size,
            type: file.type,
          },
        };
      });
    pdfFiles?.length && this.props.onSelect(pdfFiles[0]);

    if (!!this.state.over) {
      this.setState({ over: false });
    }
  };

  handleDragOver = (ev) => {
    ev.preventDefault();

    if (!this.state.over) {
      this.setState({ over: true });
    }
  };

  handleDragOut = (ev) => {
    ev.preventDefault();

    if (!!this.state.over) {
      this.setState({ over: false });
    }
  };

  render() {
    const borderColor = this.state.over ? COLOR.callToAction : '#bbb';
    const borderWidth = this.state.over ? 1.5 : 1;
    const boxWidthInDashes = 29;
    return (
      <View style={{ height: 200, borderRadius: 10, overflow: 'hidden', marginVertical: 25 }}>
        <View style={{ height: 200 }}>
          <View style={{ height: borderWidth, flexDirection: 'row', overflow: 'hidden' }}>
            {Array.from(Array(boxWidthInDashes).keys()).map((a, i) => (
              <View
                key={i}
                style={{
                  backgroundColor: borderColor,
                  height: borderWidth,
                  width: 10,
                  marginHorizontal: 5,
                }}
              />
            ))}
          </View>
          <View style={{ flex: 1, flexDirection: 'row' }}>
            <View style={{ width: borderWidth }}>
              {Array.from(Array(10).keys()).map((a, i) => (
                <View
                  key={i}
                  style={{
                    backgroundColor: borderColor,
                    width: borderWidth,
                    height: 10,
                    marginVertical: 5,
                  }}
                />
              ))}
            </View>
            <View style={{ flex: 1 }}>
              <div
                style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                onDrop={this.handleDrop}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragOut}
              >
                <Image
                  style={{ width: 75, height: 100 }}
                  source={require('../../../../../resources/icon-import-pdf-web.svg')}
                />
              </div>
            </View>
            <View style={{ width: borderWidth }}>
              {Array.from(Array(10).keys()).map((a, i) => (
                <View
                  key={i}
                  style={{
                    backgroundColor: borderColor,
                    width: borderWidth,
                    height: 10,
                    marginVertical: 5,
                  }}
                />
              ))}
            </View>
          </View>
          <View style={{ height: borderWidth, flexDirection: 'row', overflow: 'hidden' }}>
            {Array.from(Array(boxWidthInDashes).keys()).map((a, i) => (
              <View
                key={i}
                style={{
                  backgroundColor: borderColor,
                  height: borderWidth,
                  width: 10,
                  marginHorizontal: 5,
                }}
              />
            ))}
          </View>
        </View>
      </View>
    );
  }
}
